import { StaticRole } from '@markant-platform/shared/user/model';
import { Route } from '@angular/router';
import { OrganizationDetailData, QualificationLevel } from 'data-model';

export function filterByUserRoles(route: Route, userRoles: StaticRole[]): boolean {
  return (
    route.data &&
    route.data['onlyRoles'] &&
    route.data['onlyRoles'].some((onlyRole: StaticRole) => userRoles.includes(onlyRole))
  );
}

export function filterByOrganization(
  route: Route,
  userRoles: StaticRole[],
  organization: OrganizationDetailData | undefined
): boolean {
  const condition = route.data && route.data['condition'];
  if (condition) {
    if (!userRoles.includes(condition['role'])) {
      return true;
    }

    if (!organization) {
      return false;
    }

    return condition['func'](organization);
  }
  return true;
}

export function filterBySubject(route: Route, subject: string): boolean {
  if (!route.path) {
    return false;
  }

  switch (route.path) {
    case 'my-profile':
      return true;
    case 'mfa':
      return handleMfaCaseResult(subject);
    default:
      return true;
  }
}

function handleMfaCaseResult(subject: string): boolean {
  const isSsoUserResult = isSsoUser(subject);

  if (isSsoUserResult === true) {
    return false;
  } else if (isSsoUserResult === false) {
    return true;
  } else {
    return false;
  }
}

function isSsoUser(subject: string): boolean | undefined {
  if (!subject || subject === '') {
    return undefined;
  }

  const fullUserId = subject;

  const pipeIndex = fullUserId.indexOf('|');
  if (pipeIndex === -1 || pipeIndex === fullUserId.length - 1) {
    return undefined;
  }

  const prefix = fullUserId.substring(0, pipeIndex);
  const afterPipe = fullUserId.substring(pipeIndex + 1);

  if (!isAlphanumerical(prefix) || afterPipe === '') {
    return undefined;
  }

  if (prefix === 'auth0') {
    return false;
  }

  return true;
}

function isAlphanumerical(str: string): boolean {
  return str !== '' && /^[a-zA-Z0-9]+$/.test(str);
}

export function isOrgNewAndLvl3(organization: OrganizationDetailData): boolean {
  return !organization.ezrCustomer && organization.qualificationLevel === QualificationLevel.LEVEL_3;
}

export function cleanUrl(string = ''): string {
  return string.replace(/\s+/g, '-').toLowerCase();
}
